import { http } from 'connex-cds';

export default {
  deleteConnexion: ({ entityRef, profileRef }) =>
    http.delete({ apiName: 'mt', path: `/${entityRef}/connexions/${profileRef}` }),
};
